// The app's mark.
//
// Inlined rather than loaded from its url: it is 920 bytes, and a remote image
// inside a cross-origin iframe is a request that can be slow, blocked, or
// simply absent offline — for a logo that means the toolbar visibly reflows
// once the page has already been read. The source lives beside this as
// logo.svg; it came from
// storage.googleapis.com/cs_public_stuff/assets/App logos/gTable.svg
export function Logo(): JSX.Element {
  return (
    <svg
      className="gt-logo"
      width="20"
      height="20"
      viewBox="0 0 26 26"
      fill="none"
      role="img"
      aria-label="gTables"
    >
      <path d="M2.5 18.75V14.5V9V3.5H10H17.25H23.5V9V14.5V18.75V23H17.25H10H2.5V18.75Z" fill="#97F9FD"/>
      <path d="M2.5 14.5H23.5M2.5 14.5V18.75M2.5 14.5V9M23.5 14.5V18.75M23.5 14.5V9M2.5 18.75V23H10M2.5 18.75H23.5M23.5 18.75V23H17.25M2.5 9V3.5H10M2.5 9H23.5M23.5 9V3.5H17.25M10 3.5V23M10 3.5H17.25M10 23H17.25M17.25 3.5V23" stroke="black"/>
      <rect x="2.5" y="3.5" width="18" height="13" fill="white"/>
      <rect x="2.5" y="3.5" width="18" height="13" stroke="black"/>
      <path d="M4.84375 9.58807V8.84375H8.48295V9.58807H4.84375ZM4.84375 11.3381V10.5938H8.48295V11.3381H4.84375ZM10.0526 13H9.12074L11.2145 7.18182H12.2287L14.3224 13H13.3906L11.7457 8.23864H11.7003L10.0526 13ZM10.2088 10.7216H13.2315V11.4602H10.2088V10.7216ZM17.017 7.18182V13H16.1364V8.0625H16.1023L14.7102 8.97159V8.13068L16.1619 7.18182H17.017Z" fill="black"/>
    </svg>
  );
}
